import Marquee from "react-fast-marquee";

const ITEMS = [
  "ACCURATE DIAGNOSTICS",
  "EXPERT CONSULTATIONS",
  "HOME SAMPLE COLLECTION",
  "NABL-ACCREDITED LAB",
  "SAME-DAY REPORTS",
  "PATIENT-FIRST CARE",
];

export const TrustMarquee = () => {
  return (
    <div className="bg-bone border-y border-navy/10 py-8" data-testid="trust-marquee">
      <Marquee speed={32} gradient={false}>
        {ITEMS.map((item, i) => (
          <span
            key={i}
            className="font-display text-2xl md:text-3xl text-navy mx-8 flex items-center gap-8"
          >
            {item}
            <span className="w-2 h-2 rounded-full bg-teal inline-block" />
          </span>
        ))}
      </Marquee>
    </div>
  );
};
